<template>
  <div class="landing-page">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="container">
        <div class="hero-content">
          <h1 class="display-3 fw-bold mb-4">Seguimiento de Expedientes Judiciales</h1>
          <p class="lead mb-5">Mantente informado sobre tus casos legales en tiempo real. Nunca pierdas una actualización importante con nuestro sistema de notificaciones personalizadas.</p>
          <div class="d-flex justify-content-center">
            <!-- <router-link class="btn btn-light btn-lg px-5 py-3 me-3" to="/register">Registrarse</router-link> -->
            <button @click="goToRegister" class="btn btn-light btn-lg px-5 py-3 me-3">Iniciar prueba gratuita</button>
            <button @click="goToLogin" class="btn btn-outline-light btn-lg px-5 py-3">Iniciar sesión</button>
          </div>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="section bg-light" id="caracteristicas">
      <div class="container">
        <h2 class="section-title mb-5">Características Principales</h2>
        <div class="row">
          <div class="col-md-4 mb-4">
            <div class="feature-card">
              <img src="@/assets/images/calendar-icon.svg" alt="Seguimiento" class="feature-icon">
              <h3 class="feature-title">Seguimiento en Tiempo Real</h3>
              <p>Monitorea el estado de tus expedientes judiciales las 24 horas. Recibe actualizaciones inmediatas sobre cambios importantes en tus casos.</p>
            </div>
          </div>
          
          <div class="col-md-4 mb-4">
            <div class="feature-card">
              <img src="@/assets/images/email-icon.svg" alt="Notificaciones" class="feature-icon">
              <h3 class="feature-title">Notificaciones Personalizadas</h3>
              <p>Configura alertas según tus preferencias. Recibe notificaciones por correo electrónico cuando ocurran eventos importantes en tus casos.</p>
            </div>
          </div>
          
          <div class="col-md-4 mb-4">
            <div class="feature-card">
              <img src="@/assets/images/shield-icon.svg" alt="Seguridad" class="feature-icon">
              <h3 class="feature-title">Seguridad Garantizada</h3>
              <p>Tu información está protegida con los más altos estándares de seguridad. Accede a tus datos de forma segura desde cualquier dispositivo.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits Section -->
    <section class="section" id="beneficios">
      <div class="container">
        <h2 class="section-title">¿Por qué elegir nuestra plataforma?</h2>
        <div class="row align-items-center">
          <div class="col-lg-6 mb-4">
            <img src="@/assets/images/justice-icon.svg" alt="Beneficios" class="img-fluid mb-4" style="max-width: 300px; margin: 0 auto; display: block;">
          </div>
          <div class="col-lg-6">
            <div class="benefit-item">
              <img src="@/assets/images/info-icon.svg" class="benefit-icon" alt="Info">
              <div>
                <h4>Ahorro de tiempo</h4>
                <p>Evita visitas innecesarias a tribunales. Consulta el estado de tus expedientes desde cualquier lugar.</p>
              </div>
            </div>
            
            <div class="benefit-item">
              <img src="@/assets/images/info-icon.svg" class="benefit-icon" alt="Info">
              <div>
                <h4>Mayor eficiencia</h4>
                <p>Organiza y gestiona todos tus casos legales en una sola plataforma, mejorando tu productividad.</p>
              </div>
            </div>
            
            <div class="benefit-item">
              <img src="@/assets/images/info-icon.svg" class="benefit-icon" alt="Info">
              <div>
                <h4>Prevención de riesgos</h4>
                <p>Nunca pierdas una fecha importante o actualización crítica. Nuestro sistema te mantiene informado.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Statistics Section -->
    <section class="section" id="estadisticas">
      <div class="container">
        <div class="stats-container">
          <div class="row text-center">
            <div class="col-md-3 mb-4 mb-md-0">
              <div class="stat-item">
                <h2 class="stat-number">15,000+</h2>
                <p class="stat-label">Usuarios Activos</p>
              </div>
            </div>
            <div class="col-md-3 mb-4 mb-md-0">
              <div class="stat-item">
                <h2 class="stat-number">100,000+</h2>
                <p class="stat-label">Expedientes Monitorizados</p>
              </div>
            </div>
            <div class="col-md-3 mb-4 mb-md-0">
              <div class="stat-item">
                <h2 class="stat-number">98%</h2>
                <p class="stat-label">Tasa de Satisfacción</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="stat-item">
                <h2 class="stat-number">24/7</h2>
                <p class="stat-label">Monitorización Continua</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action -->
    <section class="cta-section" id="registro">
      <div class="container">
        <h2 class="display-5 fw-bold mb-4">Comienza hoy mismo</h2>
        <p class="lead mb-5">Únete a los miles de profesionales que ya confían en nuestra plataforma para el seguimiento de sus expedientes judiciales.</p>
        <button @click="goToRegister" class="btn btn-light btn-lg px-5 py-3">Iniciar prueba gratuita</button>
      </div>
    </section>
    
    <!-- Testimonials Section -->
    <section class="section bg-light" id="testimonios">
      <div class="container">
        <h2 class="section-title">Lo que dicen nuestros usuarios</h2>
        <div class="row">
          <div class="col-md-4 mb-4">
            <div class="testimonial-card">
              <div class="testimonial-content">
                <p>"Esta plataforma ha revolucionado mi forma de trabajar. Ahora puedo dar seguimiento a mis expedientes sin tener que visitar constantemente los tribunales."</p>
              </div>
              <div class="testimonial-author mt-4">
                <h5>Carlos Ramírez</h5>
                <p class="text-muted">Abogado Litigante</p>
              </div>
            </div>
          </div>
          
          <div class="col-md-4 mb-4">
            <div class="testimonial-card">
              <div class="testimonial-content">
                <p>"Las notificaciones personalizadas me permiten estar al día con mis casos sin tener que revisar manualmente cada uno. Ha mejorado significativamente mi eficiencia."</p>
              </div>
              <div class="testimonial-author mt-4">
                <h5>Ana Mendoza</h5>
                <p class="text-muted">Directora Jurídica</p>
              </div>
            </div>
          </div>
          
          <div class="col-md-4 mb-4">
            <div class="testimonial-card">
              <div class="testimonial-content">
                <p>"La facilidad de uso y la información en tiempo real hacen de esta plataforma una herramienta indispensable para cualquier profesional del derecho."</p>
              </div>
              <div class="testimonial-author mt-4">
                <h5>Roberto Gómez</h5>
                <p class="text-muted">Bufete Jurídico</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section class="section" id="contacto">
      <div class="container">
        <h2 class="section-title">Contacto</h2>
        <div class="row">
          <div class="col-md-6 mb-4">
            <form class="contact-form" @submit="handleContactSubmit">
              <div class="mb-3">
                <input type="text" name="name" class="form-control" placeholder="Nombre completo" required>
              </div>
              <div class="mb-3">
                <input type="email" name="email" class="form-control" placeholder="Correo electrónico" required>
              </div>
              <div class="mb-3">
                <textarea name="message" class="form-control" rows="5" placeholder="Mensaje" required></textarea>
              </div>
              <button type="submit" class="btn btn-primary">Enviar mensaje</button>
            </form>
          </div>
          <div class="col-md-6">
            <div class="contact-info">
              <h4 class="mb-4">Información de contacto</h4>
              <div class="contact-info-item">
                <i class="fas fa-map-marker-alt me-3"></i>
                <p>Ciudad de México, México</p>
              </div>
              <div class="contact-info-item">
                <i class="fas fa-phone me-3"></i>
                <p>+52 55 1234 5678</p>
              </div>
              <div class="contact-info-item">
                <i class="fas fa-envelope me-3"></i>
                <p>info@seguimientoexpedientes.com</p>
              </div>
              <div class="mt-4">
                <h5>Síguenos en redes sociales</h5>
                <ul class="list-inline">
                  <li class="list-inline-item"><a href="#" class="text-primary"><i class="fab fa-facebook-f"></i></a></li>
                  <li class="list-inline-item"><a href="#" class="text-primary"><i class="fab fa-twitter"></i></a></li>
                  <li class="list-inline-item"><a href="#" class="text-primary"><i class="fab fa-instagram"></i></a></li>
                  <li class="list-inline-item"><a href="#" class="text-primary"><i class="fab fa-linkedin-in"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-dark text-white py-4">
      <div class="container">
        <div class="row">
          <div class="col-md-4 mb-4">
            <h5>Seguimiento de Expedientes</h5>
            <p class="text-muted">Plataforma líder para el seguimiento y gestión de expedientes judiciales en México.</p>
          </div>
          <div class="col-md-2 mb-4">
            <h6>Enlaces</h6>
            <ul class="list-unstyled">
              <li><a href="#" class="text-muted">Inicio</a></li>
              <li><a href="#caracteristicas" class="text-muted">Características</a></li>
              <li><a href="#beneficios" class="text-muted">Beneficios</a></li>
              <li><a href="#contacto" class="text-muted">Contacto</a></li>
            </ul>
          </div>
          <div class="col-md-3 mb-4">
            <h6>Legal</h6>
            <ul class="list-unstyled">
              <li><a href="#" class="text-muted">Términos de servicio</a></li>
              <li><a href="#" class="text-muted">Política de privacidad</a></li>
              <li><a href="#" class="text-muted">Aviso legal</a></li>
            </ul>
          </div>
          <div class="col-md-3">
            <h6>Boletín informativo</h6>
            <p class="text-muted">Suscríbete para recibir noticias y actualizaciones.</p>
            <div class="input-group">
              <input type="email" class="form-control" placeholder="Tu email">
              <button class="btn btn-primary" type="button">Enviar</button>
            </div>
          </div>
        </div>
        <hr class="mt-4">
        <div class="text-center text-muted">
          <p>&copy; {{ currentYear }} Seguimiento de Expedientes. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HomeView',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    }
  },
  methods: {
    goToDashboard() {
      this.$router.push('/dashboard');
    },
    goToRegister() {
      this.$router.push({ name: 'Register' });
    },
    goToLogin() {
      this.$router.push({ name: 'Login' });
    },
    handleContactSubmit(e) {
      e.preventDefault();
      // Get form values
      const name = e.target.elements.name.value;
      const email = e.target.elements.email.value;
      const message = e.target.elements.message.value;
      
      // Here you would integrate with your backend API to send the message
      console.log('Contact form submitted:', { name, email, message });
      
      // Show success message to user (using a basic alert for now)
      // We can replace this with a proper toast component later
      alert('Tu mensaje ha sido enviado. Te contactaremos pronto.');
      
      // Reset form
      e.target.reset();
    },

  // Helper method for managing meta tags
  addOrUpdateMetaTag(name, content) {
    let tag = document.querySelector(`meta[name="${name}"]`);
    if (tag) {
      tag.setAttribute('content', content);
    } else {
      tag = document.createElement('meta');
      tag.setAttribute('name', name);
      tag.setAttribute('content', content);
      document.head.appendChild(tag);
    }
  }
  },
  metaInfo() {
    return {
      title: 'Seguimiento de Expedientes Judiciales | Plataforma de Notificaciones',
      meta: [
        { 
          name: 'description', 
          content: 'Sistema de seguimiento de expedientes judiciales en Guatemala. Recibe notificaciones sobre tus casos legales en tiempo real y mantente informado de todas las actualizaciones importantes.' 
        },
        { 
          name: 'keywords', 
          content: 'expedientes judiciales, notificaciones legales, seguimiento de casos, abogados, tribunales, juzgado, expediente judicial, Guatemala, litigios' 
        },
        { property: 'og:title', content: 'Seguimiento de Expedientes Judiciales' },
        { property: 'og:description', content: 'Sistema de seguimiento de expedientes judiciales. Recibe notificaciones sobre tus casos legales en tiempo real.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://seguimientoexpedientes.com/' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Seguimiento de Expedientes Judiciales' },
        { name: 'twitter:description', content: 'Sistema de seguimiento de expedientes judiciales. Recibe notificaciones sobre tus casos legales en tiempo real.' }
      ]
    };
  },
  mounted() {
    // If you're not using vue-meta, we need this fallback
    if (!this.$meta) {
      document.title = 'Seguimiento de Expedientes Judiciales | Plataforma de Notificaciones';
      
      // Add meta tags for SEO manually
      this.addOrUpdateMetaTag('description', 'Sistema de seguimiento de expedientes judiciales en Guatemala. Recibe notificaciones sobre tus casos legales en tiempo real.');
      this.addOrUpdateMetaTag('keywords', 'expedientes judiciales, notificaciones legales, seguimiento de casos, abogados, tribunales, juzgado, expediente judicial, Guatemala, litigios');
    }
  },
  

});
</script>